<template>
	<div class="content-tag-badges" v-if="tags.length > 0">
		<span
			v-for="tag in visibleTags"
			:key="tag.associationID"
			class="tag-badge"
		>
			{{ tag.name }}
			<i
				class="fa fa-times tag-remove-icon"
				role="button"
				title="Remove tag"
				@click.stop="removeTag(tag)"
			></i>
		</span>
		<span
			v-if="tags.length > 3"
			class="tag-more-toggle"
			role="button"
			@click.stop="showMore = !showMore"
		>{{ showMore ? "See less" : `+${tags.length - 3} more` }}</span>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
	name: "ContentTagBadges",
	props: {
		contentId: {
			type: [String, Number],
			required: true,
		},
	},
	data() {
		return {
			showMore: false,
		};
	},
	computed: {
		...mapGetters("tag", ["tagsForContent"]),
		tags() {
			return this.tagsForContent(this.contentId);
		},
		visibleTags() {
			if (this.tags.length <= 3) return this.tags;
			return this.showMore ? this.tags.slice(3) : this.tags.slice(0, 3);
		},
	},
	methods: {
		...mapActions("tag", ["deleteTagAssociation"]),
		removeTag(tag) {
			this.deleteTagAssociation({ associationID: tag.associationID, contentID: this.contentId });
		},
	},
};
</script>

<style scoped>
.content-tag-badges {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 0.375rem;
	margin-top: 0.25rem;
}

.tag-badge {
	position: relative;
	display: inline-flex;
	align-items: center;
	padding: 0.0625rem 0.5rem;
	border-radius: 1rem;
	border: 1px solid var(--primary-color, #cb222b);
	color: var(--primary-color, #cb222b);
	font-size: 0.75rem;
	line-height: 1.4;
	background-color: transparent;
}

.tag-remove-icon {
	position: absolute;
	top: -0.375rem;
	right: -0.375rem;
	width: 0.9rem;
	height: 0.9rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	background: var(--primary-color, #cb222b);
	color: #fff;
	font-size: 0.5rem;
	opacity: 0;
	visibility: hidden;
	cursor: pointer;
	transition: opacity 0.15s ease;
}

.tag-badge:hover .tag-remove-icon {
	opacity: 1;
	visibility: visible;
}

.tag-more-toggle {
	font-size: 0.75rem;
	color: var(--primary-color, #cb222b);
	cursor: pointer;
	text-decoration: underline;
	white-space: nowrap;
}
</style>
